module.exports = __webpack_public_path__ + "static/media/icon-start-date.7996a27e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DatePickerInput/icon-start-date.svg
// module id = 1196
// module chunks = 0